import React, {FC} from "react"
import Select from "@irati/ui/src/FormItem/Select"
import Validation from "@irati/utils/validation"
import {SelectionListOption} from "@irati-internal/app/src/components/RegionForm/RegionForm"
import {Region, PaymentCountryCode} from "@irati/types"

interface Props {
  region: Partial<Region>
  onChange: (fieldName: string, value: any) => void
}

const paymentCountryCodeOptions: SelectionListOption[] = Object.values(PaymentCountryCode).map((value) => {
  return {value, label: value}
})

const PaymentCountryCodeSelectionList: FC<Props> = ({region, onChange}) => {
  return (
    <Select
      name="type"
      label="Payment country code"
      value={region.paymentCountryCode}
      isClearable={false}
      options={paymentCountryCodeOptions}
      onChange={(newValue) => onChange("paymentCountryCode", newValue)}
      validation={Validation.string("Please select a value for payment country code.")}
    />
  )
}

export default PaymentCountryCodeSelectionList
